import copy from 'copy-to-clipboard';
/**
 * Copy text content to clipboard
 * todo: refactor all places using copy-to-clipboard to use this function
 */
export const copyToClip = (text) => {
    copy(text);
};
